import e from "@dialpad/dialtone-tokens/layered/themes/tokens-108-colors.css?inline";
//#region themes/108.js
var t = { brand: {
	css: e,
	name: "108"
} };
//#endregion
export { t as default };
